// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Invoice } from './invoice';
import { InvoiceFee } from './invoice-fee';
import { OrderLineDetail } from './order-line-detail';
import { PackingSlip } from './packing-slip';
import { Payment } from './payment';
import { PaymentCredit } from './payment-credit';
import { PaymentLineType } from './payment-line-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PaymentLine extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  invoiceDate: Date;
    invoiceDueDate: Date;
    invoiceAmount: number = 0;
    paidAmount: number = 0;
    startingBalance: number = 0;
    remainingBalance: number = 0;
    relatedPaymentIds: number[] = [];
    generatedDescription: string = '';
    appliedCreditIds: number[] = [];
    applyPayment: boolean = false;
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  amount!: number;
  created!: Date;
  createdBy?: string;
  creditAmount!: number;
  deleted?: Date;
  deletedBy?: string;
  description?: string;
  invoiceFeeId?: number;
  invoiceId?: number;
  lineNumber!: number;
  notes?: string;
  orderLineDetailId?: number;
  packingSlipId?: number;
  paymentCreditId?: number;
  paymentId!: number;
  paymentLineTypeId?: number;
  invoice!: Invoice;
  invoiceFee!: InvoiceFee;
  orderLineDetail!: OrderLineDetail;
  packingSlip!: PackingSlip;
  payment!: Payment;
  paymentCredit!: PaymentCredit;
  paymentLineType!: PaymentLineType;
}

